import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { createApolloClient } from "./gql/client";
import "./i18n/i18n";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/i18n";

ReactDOM.render(
  <BrowserRouter basename="/">
    <ApolloProvider client={createApolloClient}>
      {/* <PersistGate loading={null} persistor={Persistor}> */}
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
      {/* </PersistGate> */}
    </ApolloProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
